import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import WhyChooseUs from './components/WhyChooseUs';
import Process from './components/Process';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navigation from '../../components/feature/Navigation';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://auralisconsulting.io';
  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Auralis Consulting",
    "description": "Business advisory firm specializing in corporate strategy, tax optimization, international setup, and IT network management in Ras Al Khaimah, UAE",
    "url": siteUrl,
    "telephone": "+971 56 718 2619",
    "email": "auralisconsult@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Compass Building Al Shohada Road, AL Hamra Industrial Zone-FZ",
      "addressLocality": "Ras Al Khaimah",
      "addressRegion": "Ras Al Khaimah",
      "postalCode": "",
      "addressCountry": "AE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "25.6866",
      "longitude": "55.9432"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Worldwide"
    },
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Consulting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Corporate Strategy Consulting",
            "description": "Strategic business planning and corporate development services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tax Optimization",
            "description": "International tax planning and optimization strategies"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "International Business Setup",
            "description": "Company formation and international expansion services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "IT Network Management",
            "description": "Comprehensive IT infrastructure and network management solutions"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEOHead
        title="Business Consulting Corporate Strategy Tax Optimization Auralis Consulting"
        description="Ras Al Khaimah Business Consulting Corporate Strategy Tax Optimization Auralis Consulting delivers expert corporate strategy consulting, tax optimization services, international business setup, and comprehensive IT network management solutions in Ras Al Khaimah. Partner with experienced business advisors for sustainable growth and global success with our business consulting, corporate strategy, and tax optimization services."
        keywords="business consulting, corporate strategy, tax optimization"
        canonical={`${siteUrl}/`}
        schemaData={schemaData}
      />
      <div className="min-h-screen bg-white">
        <Navigation />
        <Hero />
        <Services />
        <About />
        <WhyChooseUs />
        <Process />
        <CTA />
        <Footer />
      </div>
    </>
  );
}
